//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
const qr_url = 'https://cdn.vip-wifi.com/fangchan/img/qr/chengdu/cdgfzzj.png'
export default {
    data () {
        return {
            qr_url,
            saving: false
        }
    },
    methods: {
        hide () {
            this.$emit('hide')
        },
        save () {
            wx.showLoading()
            this.saving = true
            WX_API.saveImgFromInternet({
                url: qr_url
            }).then((e) => {
                this.finishSave()
                wx.showToast({
                    title: '下载成功'
                })
            }).catch(() => {
                this.finishSave()
                wx.showToast({
                    title: '下载失败',
                    icon: 'none'
                })
            })
        },
        finishSave () {
            this.saving = false
            setTimeout(wx.hideLoading, 1500)
        },
        copyWx () {
            WX_API.setClipboardData('cdgfzzj')
        }
    },
    props: {
        show: {
            type: Boolean
        },
        content: {
            type: String
        },
        show_copy: {
            type: Boolean
        },
        title: {
            type: String
        }
    }
}
